import { heightConverter } from "Helpers/util";
export const categoryObject = {
    basics: "basics",
    dietaryRestrictions: "dietaryRestrictions",
    dietaryPreferences: "dietaryPreferences",
    nutritionGoals: "nutritionGoals",
    performanceGoals: "performanceGoals",
    exersiseHabits: "exersiseHabits",
};
export const setImageToNull = (options) => options.map((item) => ({ ...item, image: "" }));
export const getSelectedItem = (value, name, options) => options[name].find((item) => JSON.stringify(item.value) === JSON.stringify(value));
export const splitLabel = (value) => {
    if (value) {
        if (value === "Every Day") {
            return "Every Day";
        }
        return value.split(" ")[0];
    }
    return "";
};
export const getSelectedObject = (option, options) => options.find((item) => item.value.trim() === option.trim());
export const splitLabelinArray = (value) => value.map((item) => ({
    ...item,
    label: splitLabel(item.label),
}));
export const defaultQuizOptions = {
    basics: {
        height: [],
        weight: [],
        goalWeight: [],
        hoursOfSleep: [],
    },
    dietaryPreferences: {
        grains: [],
        protein_intake: [],
    },
    dietaryRestrictions: {
        dietary: [],
    },
    exersiseHabits: {
        exercises: [],
        injury: [],
        intensity1: [],
        intensity2: [],
        mainExercises: [],
        sweat: [],
        weeklyFreq1: [],
        weeklyFreq2: [],
    },
    performanceGoals: {
        performanceGoals: [],
    },
    nutritionGoals: {
        nutritionGoals: [],
    },
};
export const getCategory = (key) => {
    switch (key) {
        case "weight":
            return categoryObject.basics;
        case "height":
            return categoryObject.basics;
        case "hoursOfSleep":
            return categoryObject.basics;
        case "goalWeight":
            return categoryObject.basics;
        case "dietary":
            return categoryObject.dietaryRestrictions;
        case "fiber":
            return categoryObject.dietaryPreferences;
        case "grains":
            return categoryObject.dietaryPreferences;
        case "protein_intake":
            return categoryObject.dietaryPreferences;
        case "nutritionGoals":
            return categoryObject.nutritionGoals;
        case "performanceGoals":
            return categoryObject.performanceGoals;
        case "exercises":
            return categoryObject.exersiseHabits;
        case "mainExercises":
            return categoryObject.exersiseHabits;
        case "intensity1":
            return categoryObject.exersiseHabits;
        case "intensity2":
            return categoryObject.exersiseHabits;
        case "injury":
            return categoryObject.exersiseHabits;
        case "weeklyFreq1":
            return categoryObject.exersiseHabits;
        case "weeklyFreq2":
            return categoryObject.exersiseHabits;
        case "sweat":
            return categoryObject.exersiseHabits;
        default:
            return "";
    }
};
export const breakOptionsIntoCategories = (options) => {
    const result = {
        ...defaultQuizOptions,
    };
    const quizOptions = JSON.parse(JSON.stringify(options));
    Object.keys(quizOptions).forEach((key) => {
        const category = getCategory(key);
        if (category === categoryObject.basics) {
            result.basics = {
                ...result.basics,
                [key]: quizOptions[key],
            };
        }
        if (category === categoryObject.dietaryPreferences) {
            result.dietaryPreferences = {
                ...result.dietaryPreferences,
                [key]: quizOptions[key],
            };
        }
        if (category === categoryObject.dietaryRestrictions) {
            result.dietaryRestrictions = {
                ...result.dietaryRestrictions,
                [key]: quizOptions[key],
            };
        }
        if (category === categoryObject.exersiseHabits) {
            result.exersiseHabits = {
                ...result.exersiseHabits,
                [key]: quizOptions[key],
            };
        }
        if (category === categoryObject.nutritionGoals) {
            result.nutritionGoals = {
                ...result.nutritionGoals,
                [key]: quizOptions[key],
            };
        }
        if (category === categoryObject.performanceGoals) {
            result.performanceGoals = {
                ...result.performanceGoals,
                [key]: quizOptions[key],
            };
        }
    });
    return result;
};
export const prepareAnswerObject = (selectedAnswers) => {
    const preparedAnswersObj = {
        ...selectedAnswers,
        height: heightConverter(selectedAnswers.ft, selectedAnswers.inch),
        mainExercises: [selectedAnswers.primaryExercise || "", selectedAnswers.secondaryExercise || ""],
    };
    delete preparedAnswersObj.ft;
    delete preparedAnswersObj.inch;
    Object.keys(preparedAnswersObj).forEach((key) => {
        if (!Array.isArray(preparedAnswersObj[key]) && !["weight", "goalWeight", "height"].includes(key)) {
            preparedAnswersObj[key] = preparedAnswersObj[key] && [`${preparedAnswersObj[key]}`.trim()];
        }
        else if (Array.isArray(preparedAnswersObj[key])) {
            const answerArr = preparedAnswersObj[key];
            preparedAnswersObj[key] = answerArr.map((item) => item.trim());
        }
    });
    delete preparedAnswersObj.secondaryExercise;
    delete preparedAnswersObj.primaryExercise;
    return preparedAnswersObj;
};
export const prepapeQuizOptionsDataObj = (quizOptions) => breakOptionsIntoCategories({
    ...JSON.parse(JSON.stringify(quizOptions)),
    sweat: [
        { label: "Low", value: "Low", image: "" },
        { label: "Medium", value: "Medium", image: "" },
        { label: "High", value: "High", image: "" },
    ],
    intensity1: [
        { label: "Very Light", value: "Very Light", image: "" },
        { label: "Moderate", value: "Moderate", image: "" },
        { label: "Very Intense", value: "Very Intense", image: "" },
    ],
    intensity2: [
        { label: "Very Light", value: "Very Light", image: "" },
        { label: "Moderate", value: "Moderate", image: "" },
        { label: "Very Intense", value: "Very Intense", image: "" },
    ],
});
export const defaultAnswers = {
    dietary: [],
    fiber: "",
    goalWeight: 0,
    healthGoals: [],
    height: 0,
    hoursOfSleep: 0,
    injury: [],
    intensity1: "",
    intensity2: "",
    mainExercises: [],
    performanceGoals: [],
    protein_intake: "",
    reasons: [],
    sweat: "",
    weeklyFreq: 0,
    weeklyFreq1: "",
    weeklyFreq2: "",
    weight: 0,
    grains: "",
    pregnant: "",
};
export const editModeDefaultObj = {
    basics: false,
    dietaryPreferences: false,
    dietaryRestrictions: false,
    nutritionGoals: false,
    performanceGoals: false,
    exerciseHabits: false,
};
